var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangecircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 163.6 140.1",
    style: {
      enableBackground: "new 0 0 163.6 140.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{mask:url(#mask-2_1_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#AFFF55;}\n\t.st5{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st6{mask:url(#mask-2_2_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1_1_",
    className: "st0",
    width: 163.6,
    height: 140.1
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 163.6,
    height: 140
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 163.6,
    height: 140,
    id: "mask-2_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 163.6,
    height: 140.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1_2_",
    className: "st2",
    width: 163.6,
    height: 140.1
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.2,136.9c0-1.8-1.5-3.2-3.3-3.2c-33.3,0-60.7-25.1-64.1-57.1l9.3,6.8c1.5,1.1,3.5,0.7,4.6-0.7 c1.1-1.4,0.8-3.5-0.7-4.5L16.1,67.3l-0.3-0.2c-0.2-0.1-0.4-0.2-0.6-0.3s-0.4-0.1-0.6-0.1c-0.1,0-0.2-0.1-0.4-0.1 c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0-0.4,0.1-0.6,0.1c-0.2,0.1-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.2-0.4,0.3c-0.2,0.2-0.4,0.3-0.5,0.5 l-0.2,0.2L0.6,82.7c-1.1,1.4-0.8,3.5,0.7,4.5c0.6,0.4,1.3,0.6,1.9,0.6c1,0,2-0.5,2.6-1.3l5.6-7.6C16.1,113.4,45.9,140,82,140 C83.7,140.1,85.2,138.7,85.2,136.9L85.2,136.9z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 78.4,
    y: 0,
    width: 85.2,
    height: 73.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 78.4,
    y: 0,
    width: 85.2,
    height: 73.3,
    id: "mask-2_2_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -0.1,
    className: "st5",
    width: 163.6,
    height: 140.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1_3_",
    x: 0,
    y: -0.1,
    className: "st2",
    width: 163.6,
    height: 140.1
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.4,3.2c0,1.8,1.5,3.2,3.3,3.2c33.3,0,60.7,25.1,64.1,57.1l-9.3-6.8c-1.5-1.1-3.5-0.7-4.6,0.7 c-1.1,1.4-0.8,3.5,0.7,4.5l14.9,10.8l0.3,0.2c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.1,0,0.2,0.1,0.4,0.1 c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.4-0.1,0.6-0.1c0.2-0.1,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.2,0.4-0.3c0.2-0.2,0.4-0.3,0.5-0.5l0.2-0.2 L163,57.3c1.1-1.4,0.8-3.5-0.7-4.5c-0.6-0.4-1.3-0.6-1.9-0.6c-1,0-2,0.5-2.6,1.3l-5.6,7.6C147.5,26.7,117.7,0,81.6,0 C79.9-0.1,78.4,1.4,78.4,3.2L78.4,3.2z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangecircle);
export default __webpack_public_path__ + "static/media/changecircle.95b464fc08a22f4adc78aca75d98f0b0.svg";
export { ForwardRef as ReactComponent };